import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../environments/environment';

@Injectable()
export class AppService {
  agentInfo: any = {};

  constructor(private http: HttpClient) {
    this.getAgentData();
  }

  getAgentData()  {
    this.http.get('assets/json/config.json').subscribe(data => {
      this.agentInfo = data;
      console.log(this.agentInfo);
    });
  }

  templateData() {
    const data = {
      title: this.agentInfo.title,
      logo: this.agentInfo.logo,
      fileuploadKey: this.agentInfo.fileuploadKey
    };

    return data;
  }

  getIP(): Observable<any> {
    return this.http.get('https://api.ipify.org?format=json');
  }

  getResponse(params, query, urlData): Observable<any> {
    let getUrl = `${this.agentInfo.nlp_url}?Key=${this.agentInfo.key}&AgentID=${this.agentInfo.agent}&Location=${params.ip}&SessionID=${params.sessionID}&Say=${query}`;
    if ((urlData !== undefined) && (urlData !== null) ) {
      getUrl += `&${urlData}`;
    }
    return this.http.get(getUrl);
  }


  uploadFiles(fileData): Observable<any> {

    const body = new FormData();
    body.append('file', fileData.attachment);
    body.append('key', fileData.key);
    body.append('user_id', fileData.user);

    const url = environment.uploadBaseUrl + 'upload-file.php';
    return this.http.post(url, body );
  }

  search(searchUrl, data): Observable<any> {
    return this.http.post(searchUrl, data);
  }

  subscribe(reqUrl, data): Observable<any> {
    return this.http.post(reqUrl, data);
  }

  login(reqUrl, data): Observable<any> {
    return this.http.post(reqUrl, data);
  }

  comment(reqUrl, data): Observable<any> {
    return this.http.post(reqUrl, data);
  }

}

